import { render, staticRenderFns } from "./SelectBase.vue?vue&type=template&id=25f82d09&scoped=true&lang=pug&"
import script from "./SelectBase.vue?vue&type=script&lang=ts&"
export * from "./SelectBase.vue?vue&type=script&lang=ts&"
import style0 from "./SelectBase.vue?vue&type=style&index=0&id=25f82d09&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f82d09",
  null
  
)

export default component.exports